import { render, staticRenderFns } from "./project-three.vue?vue&type=template&id=20cec245&scoped=true&"
import script from "./project-three.vue?vue&type=script&lang=js&"
export * from "./project-three.vue?vue&type=script&lang=js&"
import style0 from "./project-three.vue?vue&type=style&index=0&id=20cec245&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cec245",
  null
  
)

export default component.exports